import React, { Component } from "react";
import { View, StyleSheet, ActivityIndicator, Dimensions } from "react-native";

class Waiting extends Component {
  constructor(props) {
    super(props)
    this.state = {
      waiting: this.props.waiting
    }
  }
  render() {
    if (this.state.waiting) {
      return <View style={styles.waitingWrapper} >
        <ActivityIndicator size="large" color="white" />
      </View>
    } else {
      return <View />
    }
  }
  componentWillReceiveProps(newprops) {
    this.setState({
      waiting: newprops.waiting
    })
  }
}
const styles = StyleSheet.create({
  waitingWrapper: {
    backgroundColor: '#00000066',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    elevation: 3,
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center'
  },
})

export default Waiting;
